import { useGetPendingSubCategory } from "@/api/console/pending-assessments/useGetPendingSubCategory";
import AdminContentContainer from "@/components/AdminContentContainer";
import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import BottomBar from "@/components/BottomBar";
import LoadingScreen from "@/components/Loading";
import {
  AnswerSubCategoryDetail,
  answerSubCategoryDetailSchema,
} from "@/schema/console/checking-assessments/AnswerSubCategoryDetail";
import ButtonGroup from "@/src/console/(auth)/(check-assessments)/check-submissions/[id]/categories/[id]/sub-categories/[id]/_components/ButtonGroup";
import Heading from "@/src/console/(auth)/(check-assessments)/check-submissions/[id]/categories/[id]/sub-categories/[id]/_components/Heading";
import AnswerContent from "@/src/console/(auth)/_components/CheckingAssessment/AnswerContent/AnswerContent";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

function SubmissionSubCategoryDetail() {
  const { id, categoryId, subCategoryId = "" } = useParams();
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      name: t("check-submissions"),
      href: "/console/check-submissions",
    },
    {
      name: t("assessment-details"),
      href: `/console/check-submissions/${id}`,
    },
    {
      name: t("categories"),
      href: `/console/check-submissions/${id}/categories/${categoryId}`,
    },
    {
      name: t("sub-categories"),
      href: `/console/check-submissions/${id}/categories/${categoryId}/sub-categories`,
    },
  ];

  const { data, isLoading } = useGetPendingSubCategory(subCategoryId, {
    revalidateOnMount: true,
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const methods = useForm<AnswerSubCategoryDetail>({
    resolver: zodResolver(answerSubCategoryDetailSchema),
    values: data?.data,
  });

  const { fields } = useFieldArray({
    control: methods.control,
    name: "answer_contents",
    keyName: "key",
  });

  if (isLoading || !data) return <LoadingScreen />;
  const { answer_contents, content, is_checked } = data.data;

  return (
    <FormProvider {...methods}>
      <AdminNavbar breadcrumbs={breadcrumbs} />
      <AdminContentContainer
        bottomBar={
          <BottomBar
            backLink={`/console/check-submissions/${id}/categories/${categoryId}`}
          >
            <ButtonGroup id={subCategoryId} />
          </BottomBar>
        }
      >
        <Heading
          content={content}
          isChecked={is_checked}
          questionCount={answer_contents.length}
        />
        <div className="w-[800px] m-auto my-8 divide-y divide-cool-gray-200 my-card">
          {fields.map((field, index) => (
            <AnswerContent key={field.key} index={index} />
          ))}
        </div>
      </AdminContentContainer>
    </FormProvider>
  );
}

export default SubmissionSubCategoryDetail;
